import apiClient from './client'; 

export const getPublicExecutors = async (params: {
  page?: number;
  size?: number;
  specializationIds?: string[];
} = {}) => {
  try {
    const response = await apiClient.get('/public/executors', { params });
    return response.data;
  } catch (err) {
    console.error('Ошибка загрузки публичных исполнителей:', err);
    return { items: [], totalElements: 0, totalPages: 0 };
  }
};

export const getExecutorById = async (executorId: string) => {
  try {
    const response = await apiClient.get(`/public/executors/${executorId}`);
    return response.data;
  } catch (err) {
    console.error(`Ошибка загрузки исполнителя ${executorId}:`, err);    
    return null;
  }
};

// Добавить функцию для получения исполнителей с игнорированием ошибок авторизации
export const getExecutorsSafe = async (params: any = {}) => {
  try {
    // Пробуем с текущим токеном
    const response = await apiClient.get('/public/executors', { params });
    return response.data;
  } catch (err) {
    return { items: [] };
  }
};